import { useState } from "react";
import { MdAccountBalanceWallet } from "react-icons/md";

import {
  Card,
  Flex,
  Heading,
  HStack,
  RefreshButton,
  Stack,
} from "components/ui";
import { useTranslation } from "hooks/useTranslation";
import { getThemeColor } from "theme/colors";

import BudgetsPanel from "./BudgetsPanel";

/**
 * Configure → Budgets & limits: alert thresholds on AI spend, optionally enforced as a hard
 * allowance. Available to every tenant — budgets meter spend that is tracked with or without the
 * AI Gateway feature. The numbers a budget is measured against live on Dashboard → AI Spend.
 */
const BudgetsPage = () => {
  const { t } = useTranslation();
  const [refreshToken, setRefreshToken] = useState(0);

  return (
    <Stack gap={4}>
      <Flex justify="space-between" align="center">
        <HStack>
          <MdAccountBalanceWallet
            size={32}
            color={getThemeColor("icon").base}
          />
          <Heading
            size="2xl"
            fontWeight="bold"
            color={{ base: "navy.700", _dark: "white" }}
          >
            {t("app.budgets.title")}
          </Heading>
        </HStack>
        <HStack gap={3}>
          <RefreshButton
            onClick={() => setRefreshToken((token) => token + 1)}
          />
        </HStack>
      </Flex>

      <Card.Root w="full">
        <Card.Body>
          <BudgetsPanel refreshToken={refreshToken} />
        </Card.Body>
      </Card.Root>
    </Stack>
  );
};

export default BudgetsPage;
